import React from "react";
import BackgroundImage from 'gatsby-background-image'
import { graphql, useStaticQuery } from 'gatsby';
import withStyles from "@material-ui/core/styles/withStyles";

function Organize({...props}) {
    const {
      className,
      imageUrl,
      children,
      style
    } = props;
    const data = useStaticQuery(
      graphql`
        query {
          desktop: file(relativePath: { eq: "organize.jpg" }) {
            childImageSharp {
              fluid(quality: 40, maxWidth: 1280) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      `
    );

    // Set ImageData.
    const imageData = data.desktop.childImageSharp.fluid;

    return (
      <BackgroundImage 
      Tag="section"
      role="img"
      aria-label="A group of demonstrators exercising their civic rights. One is holding a loudspeaker and others have their fists raised up in the air."
      className={className}
      fluid={imageData}
      style={style}
    >
      {children}
    </BackgroundImage>
    )
  }

const styles = {
  width: "100%",
  backgroundPosition: "center center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover"
}

export default withStyles(styles)(Organize)